<template>
  <v-card class="elevation-0">
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>

      <v-text-field
          v-on:keyup.enter="searchOnEnter"
          v-on:blur="searchOnEnter"
          append-icon="mdi-magnify"
          hint="Kode, Deskripsi (press ENTER to search)"
          label="Search"
          class="ml-2"
      ></v-text-field>
      <v-btn
          @click="showFilter = !showFilter"
          icon fab
          color="blue"
          small
          class="ml-2"
      >
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </v-card-title>
    <v-expand-transition>
      <v-card class="ml-2 mr-2 elevation-0 grey lighten-4 " v-show="showFilter===true">
        <v-card-text>
          <v-row>
            <v-col
                cols="12"
                sm="4"
                md="4"
            >
              <v-autocomplete
                  v-model="filterFumkmTypeList"
                  :items="itemsFUmkmType"
                  item-value="id"
                  item-text="description"
                  dense
                  small-chips
                  hide-details
                  label="Jenis UMKM"
                  class="ml-1 mr-1"
                  multiple
                  clearable
              ></v-autocomplete>
            </v-col>
            <v-col
                cols="12"
                sm="4"
                md="4"
            >
              <v-autocomplete
                  v-model="filterFsubAreaList"
                  :items="itemsFSubArea"
                  item-value="id"
                  item-text="description"
                  dense
                  small-chips
                  hide-details
                  label="Kelurahan/Desa"
                  class="ml-1 mr-1"
                  multiple
                  clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" sm="2" md="2">
              <v-btn color="primary" small @click="fetchFUmkm">
                Terapkan
                <v-icon small class="ml-1" color="green lighten-2">mdi-filter</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-expand-transition>
    <v-data-table
        v-model="selectedItems"
        :single-select="!multiSelect"
        :show-select="multiSelect"
        :headers="headers"
        :items="fumkmsFiltered"
        :page.sync="currentPage"
        :items-per-page="pageSize"
        hide-default-footer
        class="elevation-0"
        align="start"
    >
      <template v-slot:top>
        <v-row align="center" class="ml-4 mr-4">
          <v-switch
              v-model="multiSelect"
              :label="multiSelect ? 'Multi Select' : 'Single Select'"
              x-small
              class="pa-3"
          ></v-switch>
          <v-btn
              fab
              dark
              color="red accent-4"
              x-small
              :disabled="!multiSelect"
              class="mr-2"
              @click="deleteDialogMultiShow"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
              fab
              dark
              color="green"
              x-small
              @click="showDialogNew"
              :disabled="multiSelect"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-menu offset-y style="align-items: start">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="ml-2"
                  fab
                  dark
                  x-small
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon>mdi-view-grid</v-icon>
              </v-btn>
            </template>
            <v-list color="grey lighten-4">
              <v-list-item>
                <v-btn
                    plain
                    elevation="0"
                    color="gray darken-1"
                    small
                    @click="exportToExcel"
                >
                  <v-icon color="green">mdi-file-excel</v-icon>
                  Aset to Excel
                </v-btn>
              </v-list-item>
              <v-list-item>
                <v-btn
                    plain
                    elevation="0"
                    color="gray darken-1"
                    small
                    @click="importDialogShow"
                >
                  <v-icon color="green">mdi-upload</v-icon>
                  Import Aset
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </template>

      <template v-slot:[`item.number`]="{ index }">
        {{ index + (currentPage - 1) * pageSize + 1 }}
      </template>

      <template v-slot:[`item.description`]="{ item }">
        <div class="font-weight-bold subtitle-2">
          {{ item.description }}
        </div>
        <span class="caption font-weight-light"
        >{{
            lookupFArea(lookupFSubArea(item.fsubAreaBean).fareaBean)
                .description
          }}, {{ lookupFSubArea(item.fsubAreaBean).description }}</span
        >
      </template>

      <template v-slot:[`item.fumkmTypeBean`]="{ item }">
        <span class="caption font-weight-normal">{{
            lookupFUmkmType(item.fumkmTypeBean).description
          }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="getColorStatusActive(item.statusActive)" dark small>
          {{ item.statusActive == true ? "Aktif" : "Non-Aktif" }}
        </v-chip>
      </template>

      <template v-slot:[`item.image`]="{ item }">
        <v-img
            :lazy-src="lookupImageUrlLazy(item)"
            :src="lookupImageUrl(item)"
            width="100px"
            height="100px"
            class="ma-2 rounded"
        >
        </v-img>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="showDialogEdit(item)" icon :disabled="multiSelect">
          <v-icon small color="warning"> mdi-pencil </v-icon>
        </v-btn>

        <v-btn @click="deleteDialogShow(item)" icon :disabled="multiSelect">
          <v-icon small color="red accent-4"> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-container>
      <v-row justify="end" align="center">
        <v-col cols="4" md="2" sm="2">
          <v-select
              v-model="pageSize"
              :items="pageSizes"
              label="Items per page"
          ></v-select>
        </v-col>
        <v-col cols="10" md="9" sm="8" align="right">
          <v-pagination
              v-model="currentPage"
              :length="totalPaginationPages"
              total-visible="8"
              circle
          ></v-pagination>
        </v-col>
      </v-row>
    </v-container>

    <DeleteDialog
        ref="refDeleteConfirmDialog"
        @eventFromDeleteConfirmDialog1="deleteItemConfirmedSingleSelect"
        @eventFromDeleteConfirmDialog2="deleteItemConfirmedMultiSelect"
    ></DeleteDialog>

    <FUmkmDialog
        :formMode.sync="formMode"
        ref="refFormDialog"
        @eventFromFormDialogNew="saveDataNew"
        @eventFromFormDialogEdit="saveDataEdit"
    ></FUmkmDialog>

    <v-snackbar v-model="snackbar">
      {{ snackBarMesage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import FUmkmService from "@/services/apiservices-umkm/f-umkm-service";
import FDivisionService from "@/services/apiservices/f-division-service";
import FileService from "@/services/apiservices-umkm/file-service";
import FUmkmTypeService from "@/services/apiservices-umkm/f-umkm-type-service";
import FPermitService from "@/services/apiservices-umkm/f-permit-service";

import DeleteDialog from "@/components/utils/DeleteConfirmDialog";
import FUmkmDialog from "./FUmkmObjectDialog.vue";
import FormMode from "@/models/form-mode";
import FUmkm from "@/models/umkm/f-umkm";
import FPermit from "@/models/umkm/f-permit";
import FUmkmType from "@/models/umkm/f-umkm-type";

import { format, parseISO } from "date-fns";
import FunReport from "@/services/fungsi/fun-report-standart";

import writeXlsxFile from "write-excel-file";
import FileSaver from "file-saver";
import ESchemaObject from "@/models/e-schema-object";
import FAreaService from "@/services/apiservices/f-area-service";
import FSubAreaService from "@/services/apiservices/f-sub-area-service";
import FUmkmFilter from "@/models/payload/f-potensi-filter";

export default {
  components: { FUmkmDialog, DeleteDialog },
  data() {
    return {
      title: "Daftar UMKM",
      snackbar: false,
      snackBarMesage: "",
      showFilter: false,
      multiSelect: false,
      selectedItems: [],
      imageBrokenLink: "./assets/img_sample/sample-1.jpeg",
      filterFsubAreaList: [],
      filterFareaList: [],
      filterFumkmTypeList: [],
      uploadDropDialog: false,

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 10,
      pageSizes: [10, 25, 50, 150, 500],

      search: "",
      headers: [
        {
          text: "No",
          value: "number",
          width: "7%",
          sortable: false,
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "image",
          width: "12%",
        },
        { text: "Nama UMKM", value: "description", width: "25%" },
        { text: "Jenis UMKM", value: "fumkmTypeBean", width: "30%" },
        { text: "Alamat", value: "address", width: "15%" },
        { text: "Status", value: "status", width: "10%" },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          width: "20%",
          sortable: false,
        },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      fumkms: [new FUmkm()],
      itemsFDivision: [],
      itemsFDivisionLookup: [],
      itemsFUmkmType: [new FUmkmType()],
      itemsFPermit: [new FPermit()],

      reportFields: FunReport.getHeaderRepObject,
    };
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (value) this.fetchFUmkm();
      },
    },

    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage === 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.fetchFUmkm();
        }
      },
    },
  },
  computed: {
    itemsFSubArea() {
      return this.$store.state.umkm.itemsFSubArea;
    },
    itemsFArea() {
      return this.$store.state.umkm.itemsFArea;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    fumkmsFiltered() {
      return this.fumkms;
    },
  },
  methods: {
    searchOnEnter(event) {
      if (this.search !== event.target.value) {
        //Krusial untuk search

        this.currentPage = 1;
        this.search = event.target.value;
        this.fetchFUmkm();
      }
    },
    fetchParent() {
      FDivisionService.getAllFDivision().then(
          (response) => {
            this.itemsFDivisionLookup = response.data;
          },
          (error) => {
            console.log(error.response);
          }
      );

      if (this.currentUser.organizationLevel === "CORP") {
        FDivisionService.getAllFDivision().then(
            (response) => {
              this.itemsFDivision = response.data;
            },
            (error) => {
              console.log(error.response);
            }
        );
      } else if (this.currentUser.organizationLevel === "DIV") {
        FDivisionService.getFDivisionById(this.currentUser.fdivisionBean).then(
            (response) => {
              this.itemsFDivision = [response.data];
            },
            (error) => {
              console.log(error.response);
            }
        );
      }
      FPermitService.getAllFPermit().then(
          (response) => {
            this.$store.dispatch("permit/updateItemsFPermit", response.data);
            this.itemsFPermit = response.data;
          },
          (error) => {
            console.log(error.response);
          }
      );
      FUmkmTypeService.getAllFUmkmType().then(
          (response) => {
            this.itemsFUmkmType = response.data;
          },
          (error) => {
            console.log(error.response);
          }
      );

      FAreaService.getAllFArea().then(
          (response) => {
            this.$store.dispatch("umkm/updateItemsFArea", response.data);
          },
          (error) => {
            console.log(error);
          }
      );
      FSubAreaService.getAllFSubArea().then(
          (response) => {
            this.$store.dispatch("umkm/updateItemsFSubArea", response.data);
          },
          (error) => {
            console.log(error);
          }
      );
    },
    fetchFUmkm() {
      const fumkmFilter = new FUmkmFilter();

      fumkmFilter.pageNo = this.currentPage;
      fumkmFilter.pageSize = this.pageSize;
      fumkmFilter.search = this.search;

      fumkmFilter.fsubAreaIds = this.filterFsubAreaList;
      // fumkmFilter.fareaIds = this.filterFareaList;
      fumkmFilter.fumkmTypeIds = this.filterFumkmTypeList;
      FUmkmService.getAllFUmkmContainingExt(
          fumkmFilter
      ).then(
          (response) => {
            const { items, totalPages } = response.data;
            this.totalPaginationPages = totalPages;
            this.fumkms = items
          },
          (error) => {
            console.log(error.response);
          }
      );
    },

    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },

    showDialogNew() {
      this.itemSelectedIndex = -1;
      const itemModified = Object.assign({}, "");
      this.formMode = FormMode.NEW_FORM;
      this.$refs.refFormDialog.showDialog(
          this.itemSelectedIndex,
          itemModified,
          this.itemsFDivision,
          this.itemsFUmkmType
      );
    },
    saveDataNew(itemFromRest) {
      this.itemSelected = itemFromRest;
      this.closeDialog();
      /**
       * Setiap data baru harus terlihat
       */

      this.fetchFUmkm();
    },

    showDialogEdit(item) {
      this.itemSelectedIndex = this.fumkmsFiltered.indexOf(item);
      const itemModified = Object.assign({}, item);
      // this.formDialogShow = true
      this.formMode = FormMode.EDIT_FORM;
      this.$refs.refFormDialog.showDialog(
          this.itemSelectedIndex,
          itemModified,
          this.itemsFDivision,
          this.itemsFUmkmType
      );
    },
    saveDataEdit(item) {
      this.itemSelected = item;
      try {
        //Kalau Create terus uplaod image duluan tidak bisa
        Object.assign(this.fumkms[this.itemSelectedIndex], this.itemSelected);
      } catch (e) {
        this.fetchFUmkm();
        console.log(e);
      }
      this.closeDialog();
    },

    deleteDialogShow(item) {
      this.itemSelectedIndex = this.fumkmsFiltered.indexOf(item);
      this.itemSelected = Object.assign({}, item);
      this.$refs.refDeleteConfirmDialog.showDialog(
          this.itemSelectedIndex,
          item.username
      );
    },
    deleteDialogMultiShow() {
      if (this.multiSelect === true) {
        this.$refs.refDeleteConfirmDialog.showDialogMulti(
            this.selectedItems,
            `${this.selectedItems.length} items selected`
        );
      }
    },
    deleteItemConfirmedSingleSelect(index) {
      console.log("delete SingleItem: " + index);

      const deletedItem = this.fumkms[this.itemSelectedIndex];
      FUmkmService.deleteFUmkm(deletedItem.id).then(
          () => {
            this.fumkms.splice(this.itemSelectedIndex, 1);
            this.closeDialog();
          },
          (error) => {
            console.log(error);
            this.snackBarMesage = "gagal hapus (digunakan oleh data anakk)";
            this.snackbar = true;
            this.$refs.refDeleteConfirmDialog.setDialogState(false);
          }
      );
    },
    deleteItemConfirmedMultiSelect(items) {
      if (items.length > -1) {
        let itemIds = [];
        for (let i = 0; i < items.length; i++) {
          itemIds.push(items[i].id);
        }
        FUmkmService.deleteAllFUmkm(itemIds).then(
            (response) => {
              if (response.data) {
                for (let i = 0; i < items.length; i++) {
                  if (
                      !response.data.includes(items[i].id) ||
                      response.data.length === 0
                  ) {
                    const index = this.fumkmsFiltered.indexOf(items[i]);
                    this.fumkms.splice(index, 1);
                  }
                  if (response.data.length > 0) {
                    this.snackBarMesage = `${response.data.length} items gagal hapus (digunakan oleh data anak)`;
                    this.snackbar = true;
                  }
                }
                this.closeDialog();
              }
            },
            (error) => {
              console.log("error " + error);
            }
        );
      }
    },
    closeDialog() {
      // this.myConfirmDialog = false
      this.formMode = "";
      this.$refs.refDeleteConfirmDialog.setDialogState(false);
      this.$refs.refFormDialog.setDialogState(false);

      this.$nextTick(() => {
        this.itemSelected = Object.assign({}, new FUmkm());
        this.itemSelectedIndex = -1;
      });
    },

    exportToExcel() {
      // https://www.npmjs.com/package/read-excel-file
      // https://www.npmjs.com/package/file-saver
      // https://www.npmjs.com/package/write-excel-file

      let schema = ESchemaObject;

      let fileBits = "file_kegiatan.xlsx";
      writeXlsxFile(this.fumkmsFiltered, {
        schema,
        fileName: fileBits,
      });

      // let file = new File(["Hello, world!"], "hello world.txt", {type: "text/plain;charset=utf-8"});
      let file = new File(fileBits, "hello world.txt", {
        type: "xlsx/plain;charset=utf-8",
      });
      FileSaver.saveAs(file);
    },

    importDialogShow() {
      this.$refs.refImportObjectDialog.showDialog();
    },
    importExcelCompleted(value) {
      if (value === "OKE") {
        this.fetchFUmkm();
      }
    },
    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    fetchReportData() {
      return this.fumkms.map((item) => {
        return FunReport.formatToRepObject(
            item,
            this.itemsFDivision,
            this.itemsFUmkmType
        );
      });
    },

    lookupFSubArea(fsubAreaBean) {
      const str = this.itemsFSubArea.filter((x) => x.id == fsubAreaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFUmkmType(fumkmTypeBean) {
      const str = this.itemsFUmkmType.filter((x) => x.id == fumkmTypeBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFArea(fareaBean) {
      const str = this.itemsFArea.filter((x) => x.id == fareaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id == fdivisionBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
      // return FileService.getImageTest(item)
    },
    lookupImageUrlLazy(item) {
      // return './assets/images/no_image_available.jpeg'
      return FileService.image_url_verylow(item.avatarImage);
    },

    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd-MMM-yyyy") : "";
    },
    formattedCurrencyValue(prefix, value) {
      if (!value) {
        return "0";
      }
      return prefix + "" + parseFloat(value).toLocaleString();
    },
  },
  mounted() {
    this.fetchParent();
    this.fetchFUmkm();
  },
};
</script>

<style scoped>
</style>